import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ComparisonSection() {
  return <section id="why-qtap" className="py-10 md:py-20 bg-brand-dark relative overflow-hidden" data-id="element-36">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-38">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-brand-cyan font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-39">
            Why Qtap
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-3xl md:text-5xl font-heading font-bold text-white" data-id="element-40">
            Not All Smart Clothing Is Created Equal
          </motion.h2>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="glass-card overflow-hidden" data-id="element-41">
          <div className="p-4 sm:p-6 md:p-8" data-id="element-42">
            {/* Table Header */}
            <div className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 pb-4 md:pb-6 border-b border-white/10 items-end" data-id="element-43">
              <div className="text-transparent text-xs" data-id="element-44">Feature</div>
              <div className="text-center font-heading font-bold text-[10px] sm:text-sm md:text-lg text-brand-cyan leading-tight whitespace-nowrap" data-id="element-45">
                Qtap Smart T-Shirt
              </div>
              <div className="text-center font-body text-gray-400 text-[11px] md:text-base leading-tight" data-id="element-46">
                QR Code
                <span className="hidden sm:inline" data-id="element-47"> Shirts</span>
              </div>
              <div className="text-center font-body text-gray-400 text-[11px] md:text-base leading-tight" data-id="element-48">
                Regular
                <span className="hidden sm:inline" data-id="element-49"> Merch</span>
              </div>
            </div>

            {/* Row 1: Dynamic Content */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-50">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-51">
                Dynamic Content
              </div>
              <div className="flex justify-center" data-id="element-52">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-53">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-54" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-55">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-56" />
              </div>
              <div className="flex justify-center" data-id="element-57">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-58" />
              </div>
            </motion.div>

            {/* Row 2: No App Needed to Scan */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.35
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-59">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-60">
                No App Needed
              </div>
              <div className="flex justify-center" data-id="element-61">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-62">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-63" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-64">
                <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-65" />
              </div>
              <div className="flex justify-center" data-id="element-66">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-67" />
              </div>
            </motion.div>

            {/* Row 3: Instant Tap Connection */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-68">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-69">
                Instant Tap
              </div>
              <div className="flex justify-center" data-id="element-70">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-71">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-72" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-73">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-74" />
              </div>
              <div className="flex justify-center" data-id="element-75">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-76" />
              </div>
            </motion.div>

            {/* Row 4: Updatable Profile */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.45
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-77">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-78">
                Updatable Profile
              </div>
              <div className="flex justify-center" data-id="element-79">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-80">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-81" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-82">
                <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-83" />
              </div>
              <div className="flex justify-center" data-id="element-84">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-85" />
              </div>
            </motion.div>

            {/* Row 5: Premium Design */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.5
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-86">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-87">
                Premium Design
              </div>
              <div className="flex justify-center" data-id="element-88">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-89">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-90" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-91">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-92" />
              </div>
              <div className="flex justify-center" data-id="element-93">
                <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-94" />
              </div>
            </motion.div>

            {/* Row 6: Works Offline (NFC) */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.55
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 border-b border-white/5 items-center" data-id="element-95">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-96">
                Works Offline
              </div>
              <div className="flex justify-center" data-id="element-97">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-98">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-99" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-100">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-101" />
              </div>
              <div className="flex justify-center" data-id="element-102">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-103" />
              </div>
            </motion.div>

            {/* Row 7: Waterproof */}
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr_1fr] gap-2 md:gap-4 py-3.5 md:py-5 items-center" data-id="element-104">
              <div className="font-medium text-gray-200 text-xs md:text-base" data-id="element-105">
                Waterproof
              </div>
              <div className="flex justify-center" data-id="element-106">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-brand-cyan/20 flex items-center justify-center" data-id="element-107">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-brand-cyan" data-id="element-108" />
                </div>
              </div>
              <div className="flex justify-center" data-id="element-109">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-110" />
              </div>
              <div className="flex justify-center" data-id="element-111">
                <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500/50" data-id="element-112" />
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}